import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import "../css/announcement.css";

function AnnouncementBar() {

    const [announcement, setAnnouncement] = useState(null);

    useEffect(() => {

        axios
            .get(`${API_URL}/announcement`)
            .then((res) => {
                setAnnouncement(res.data);
            })
            .catch(console.log);

    }, []);

    if (!announcement || !announcement.message) {
        return null;
    }

    return (

        <div
            className="announcement"
            style={{
                background: announcement.background_color,
                color: announcement.text_color
            }}
        >

            <marquee>

                {announcement.message}

            </marquee>

        </div>

    );

}

export default AnnouncementBar;